<div class="on-boarding-progress" *ngIf="authService.needToCompletedOnboarding()">
  <div class="header">
    <h1 class="title">¡Ya falta poco para poder operar!</h1>
    <p class="subtitle">
      Completá el último paso y disfrutá de todos los servicios de TiendaCrypto
    </p>
  </div>
  <div class="onboarding-cards">
    <div class="onboarding-card completed">
      <div class="info-container">
        <img src="assets/icons/checked-onboarding.svg" alt="" class="checked-icon" />
        <div class="info-data">
          <p class="info-step">01</p>
          <p class="info-title">Creá tu cuenta</p>
          <p class="info-subtitle">Creá un usuario y una contraseña</p>
        </div>
      </div>
      <img class="icon" src="assets/icons/password-onboarding.svg" alt="" />
    </div>
    <div class="onboarding-card completed">
      <div class="info-container">
        <img src="assets/icons/checked-onboarding.svg" alt="" class="checked-icon" />
        <div class="info-data">
          <p class="info-step">02</p>
          <p class="info-title">Verificá tu mail</p>
          <p class="info-subtitle">Activá tu cuenta desde el link que enviamos a tu casilla</p>
        </div>
      </div>
      <img class="icon" src="assets/icons/mail-onboarding.svg" alt="" />
    </div>
    <div class="onboarding-card active">
      <div class="info-container">
        <img
          src="assets/icons/unchecked-onboarding.svg"
          alt=""
          *ngIf="authService.hasToUploadDocuments()"
          class="unchecked-icon"
        />
        <img
          src="assets/icons/checked-onboarding.svg"
          alt=""
          *ngIf="!authService.hasToUploadDocuments()"
          class="checked-icon"
        />
        <div class="info-data">
          <p class="info-step">03</p>
          <p class="info-title">Completá tu perfil</p>
          <p class="info-subtitle">Completá los datos y la documentación para operar</p>
        </div>
      </div>
      <img class="icon" src="assets/icons/id-onboarding.svg" alt="" />
      <button class="td-btn primary complete" (click)="createUuid()">Completar ahora</button>
    </div>
  </div>
</div>
<div
  class="on-boarding-pending"
  *ngIf="!authService.needToCompletedOnboarding() && !authService.hasValidatedDocuments()"
>
  <app-reminder-message
    message="Estamos validando tu documentación"
    type="reminder"
    [loadingIcon]="true"
  ></app-reminder-message>
</div>
